export enum TabType {
  FirstTab,
  SecondTab,
}
